import React, { useContext, useState, useEffect } from 'react';
import { Col, Row } from 'reactstrap';

import { color } from '~/assets/styles/colors';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AddCircleOutline } from '@mui/icons-material';
import { Text } from '~/components/Text';
import { ExtratoCreditoRevenda } from '../../../components/ExtratoData/ExtratoCreditoRevenda';
import { ModalSolicitarPedido } from '../../../components/Modal/SolicitarPedido';

import { PedidoContext } from '../../../context/PedidoContext';
import { ButtonStyleLancamento } from './styles';
import { Montante } from '../../../components/Montante';


function CredRevenda(props) {
	const { user, isMobile } = props;

	const {
		loadingResumo,
		setLoadingResumo,
		getResumo,
		dataResumo,
		setPedidos,
		getPedidos,
		totalItemsResumo,
		setDataResumo,
		destinatarios,
		getExportResumo,
		loadingRevendedores,
	} = useContext(PedidoContext);

	const [atualizaNF, setAtualizaNF] = useState('');
	const [toggle, setToggle] = useState(false);

	const [, setMeusLancamentos] = useState([]);
	const [, setTotalItems] = useState(0);

	const [expanded, setExpanded] = useState(false);

	const handleChange = (panel) => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : false);
	};

	useEffect(() => {
		getResumo(10, 1, '', '')
		getPedidos(10, 1, 'enviados', '', '', 0).then(res => {
			res?.data?.total && setTotalItems(res.data.total);
			res?.data?.pedidos && setMeusLancamentos(res.data.pedidos);
		});
	}, []);

	useEffect(() => {
		getPedidos(10, 1, 'enviados', '', '', 0).then(res => {
			res?.data?.total && setTotalItems(res.data.total);
			res?.data?.pedidos && setMeusLancamentos(res.data.pedidos);
			if (atualizaNF === 'mudou') {
				setAtualizaNF('')
			}
		});
	}, [atualizaNF]);


	const RowCred = (
		<Col sm="12" md="8" lg="9">
			<>
				{(user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor') && (user.dados.permissoes.view_farmacias ? <Text style={{ margin: '0 0 10px 0' }}>CRÉDITO POR FARMÁCIA</Text>
					: <Text style={{ margin: '0 0 10px 0' }}>CRÉDITO POR REVENDA</Text>
				)}
				{(user.dados.cargo.toLowerCase() === 'industria') && <Text style={{ margin: '0 0 10px 0' }}>CRÉDITO DISTRIBUIDOR</Text>}
				<ExtratoCreditoRevenda
					isMobile={isMobile}
					totalItemsResumo={totalItemsResumo}
					getResumo={getResumo}
					setDataResumo={setDataResumo}
					resumos={dataResumo && dataResumo.dados ? dataResumo.dados : []}
					user={user}
					loadingResumo={loadingResumo}
					setLoadingResumo={setLoadingResumo}
					loadingRevendedores={loadingRevendedores}
					getExportResumo={getExportResumo}
				/>
			</>
		</Col>
	)

	return (
		<>
			{isMobile ?
				<Accordion style={{ margin: '20px 0 20px 0', backgroundColor: color.greenLight }} expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel1bh-content"
						id="panel1bh-header"
						style={{ backgroundColor: color.primary }}
					>
						<Typography sx={{ width: '100%', flexShrink: 0 }}>
							{user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' && <Text>Cred. Revenda</Text>}
							{user.dados.cargo.toLowerCase() === 'industria' && <Text>Cred. Distribuidor</Text>}
						</Typography>
					</AccordionSummary>
					<Row style={{ padding: '10px' }}>{RowCred}</Row>
				</Accordion>
				:
				<div>
					<Row style={{ padding: '10px' }}>
						{RowCred}
						<Col sm="12" md="4" lg="3">
							{user.dados.permissoes.view_credito_revenda ?
								<Montante data={dataResumo} /> : <></>}
							<div className={`d-flex ${isMobile ? 'justify-content-center' : 'justify-content-end'}`}>
								<ButtonStyleLancamento
									className="novoPedido"
									type="button"
									onClick={() => {
										setToggle(true)

									}}>
									<AddCircleOutline className="mr-2" />
									NOVO LANÇAMENTO
								</ButtonStyleLancamento>
							</div>
						</Col>
					</Row>
				</div>
			}
			{toggle &&
				<ModalSolicitarPedido
					destinatarios={destinatarios}
					setMeusLancamentos={setMeusLancamentos}
					setPedidos={setPedidos}
					setAtualizaNF={setAtualizaNF}
					toggle={toggle}
					setToggle={setToggle}
				/>}
		</>
	);
}

export default CredRevenda;
